export interface tariff {
  [x: string]: string | boolean | number | string[];
  name: string;
  status: boolean;
  description: string;
  cost: number;
  dignities: string[];
}
export const tariffList: tariff[] = [
  {
    name: "Бета",
    status: true,
    description: "Подходит для всех клиник",
    cost: 2000,
    dignities: [
      "Интеграция с МИС",
      "Выгрузка расписания",
      "Неограниченное кол-во врачей",
      "Интеграция с Метрикой",
      "Интеграция с AmoCRM",
      "Интеграция с сайтом",
      "Интеграция с Телеграмом",
      "Онлайн-запись"
    ]
  },
  {
    name: "",
    status: false,
    description: "Подходит для всех клиник",
    cost: 4000,
    dignities: [
      "Интеграция с МИС",
      "Выгрузка расписания",
      "Неограниченное кол-во врачей",
      "Интеграция с Метрикой",
      "Интеграция с AmoCRM",
      "Интеграция с сайтом",
      "Интеграция с Телеграмом",
      "Онлайн-запись"
    ]
  },
  {
    name: "",
    status: false,
    description: "Подходит для всех клиник",
    cost: 4000,
    dignities: [
      "Интеграция с МИС",
      "Выгрузка расписания",
      "Неограниченное кол-во врачей",
      "Интеграция с Метрикой",
      "Интеграция с AmoCRM",
      "Интеграция с сайтом",
      "Интеграция с Телеграмом",
      "Онлайн-запись"
    ]
  }
];
